import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WalletIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M6.58002 7.59979C6.09998 7.59979 5.76 7.2398 5.76 6.77978C5.76 6.31982 6.12 5.95977 6.58002 5.95977H16.92V4.31982H6.52002C5.12 4.31982 4.12 5.3598 4.12 6.77978V17.2198C4.12 18.6398 5.12 19.6798 6.52002 19.6798H19.88V7.59979H6.58002ZM18.24 18.0398H6.52002C6.03998 18.0398 5.76 17.6798 5.76 17.2198V9.2398H18.24V18.0398ZM16.38 11.9998H14.6999V15.6998H16.38V11.9998Z"
      />
    </SvgIcon>
  );
});
